export enum ELogisticsAccreditationStatus {
  NOT_STARTED = 'NOT_STARTED',
  ADMIN_APPROVES = 'ADMIN_APPROVES',
  BUYER_SIGNING = 'BUYER_SIGNING',
  LOGISTICS_OPERATOR_SIGNING = 'LOGISTICS_OPERATOR_SIGNING',
  APPROVED = 'APPROVED',
}
